import { h } from 'preact'

export default function listProgressRatioView (listProgress, prop, label) {
  if (listProgress[prop] == null) return
  return h('div', { class: `statistic ${prop}` },
    h('div', { class: 'datum' }, listProgress[prop]),
    h('div', { class: 'label' }, label || prop)
  )
}
